import { api, formDataApi, wildApi } from "./api";

export const getStatistic = async (postId: number) => {
  try {
    const params = { postId };
    const { data } = await api().get("/statistic", { params });
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const postStatisticExcel = async (postId: number, file: File) => {
  try {
    const body = { file };
    const { data } = await formDataApi().post(
      `/statistic/excel?postId=${postId}`,
      body
    );
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getFileList = async (postId: number) => {
  try {
    const params = { postId };
    const { data } = await api().get("/statistic-files", { params });
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const deleteStatisticFile = async (fileId: number) => {
  try {
    const { data } = await api().delete(`/statistic-files/${fileId}`);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const downloadStatisticFile = async (fileId: number) => {
  try {
    const { data } = await api().get(`/statistic-files/download/${fileId}`, {
      responseType: "blob",
    });
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

/* ========================================================================== */
/*                                  ONCOPLOT                                  */
/* ========================================================================== */
export const getOncoplot = async (postId: number) => {
  try {
    const { data } = await api().get(`/statistic/oncoplot/${postId}`);
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getOncoplotImg = async (oncoplotId: number) => {
  try {
    if (!oncoplotId) return;

    const { data } = await wildApi().get(
      `/statistic/oncoplot/img/${oncoplotId}`
    );
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const downloadStatisticOncoplotFile = async (oncoplotId: number) => {
  try {
    const { data } = await api().get(
      `/statistic/oncoplot/excel/${oncoplotId}`,
      {
        responseType: "blob",
      }
    );
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const postOncoplotGraph = async (statisticOncoplotFileId: number) => {
  try {
    const body = { statisticOncoplotFileId };
    const { data } = await api().post(`/statistic/oncoplot/graph`, body);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const postOncoplotExcel = async (postId: number, file: File) => {
  try {
    const body = { file };
    const { data } = await formDataApi().post(
      `/statistic/oncoplot/excel?postId=${postId}`,
      body
    );
    return data.data;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getMainStats = async() => {
  try {
    const { data } = await api().get('/dashboard');
    return data.data;
  } catch (e) {
    console.log(e);
    return { totalPosts: 0, totalSlides: 0 };
  }
};